
import { useEffect, useState, useRef, useMemo } from 'react';
import { getMetafieldMap } from '@/utils/Metafields';

export default function ProductSticky({
  scrollReference,
  product,
  variantPrice,
  comparePrice,
}) {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [enableButton, setEnableButton] = useState(false);
  const buttonRef = useRef(null);
  const metafieldMap = useMemo(() => {
    return getMetafieldMap(product);
  }, [product?.id]);
  const ingredient = metafieldMap.custom_ingredient_title;
  const productTitle = metafieldMap.custom_product_title || product.title;

  const firstMedia = product?.media.find((media) => {
    let image = null;

    if (media?.mediaContentType === 'IMAGE') {
      image = media;
    }

    return image;
  });

  const updateScrollPosition = () => {
    setScrollPosition(window.scrollY);
  };

  const scrollTop = () => {
    buttonRef.current.blur();
    window.scrollTo({
      top: scrollReference.current.offsetTop - 100,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', updateScrollPosition);
    return () => {
      window.removeEventListener('scroll', updateScrollPosition);
    };
  }, []);

  useEffect(() => {
    setEnableButton(
      scrollPosition >=
        scrollReference.current.offsetTop + scrollReference.current.clientHeight
    );
  }, [scrollPosition]);

  return (
    <div
      className={`fixed top-[93px] left-0 right-0 z-10 flex w-full transform justify-between border-b border-grey-7 bg-white px-2 py-2 transition-all duration-300 ease-in-out lg:top-[82px] lg:px-12 ${
        enableButton
          ? 'pointer-events-auto translate-y-0 opacity-100'
          : 'pointer-events-none -translate-y-full opacity-0'
      }`}
    >
      <div className="flex items-center gap-2 pr-3 lg:pr-0">
        {firstMedia && (
          <div className="hidden h-16 w-16 lg:block">
            <div className="responsive-image pb-full">
              <img src={firstMedia.image.src} alt={firstMedia.image.altText} />
            </div>
          </div>
        )}

        <div>
          {ingredient && (
            <p className="mb-0 hidden font-tiempos text-h6-m italic text-grey-1 lg:block">
              {ingredient}
            </p>
          )}

          <p className="mb-0 font-tiempos text-sm md:text-h5">{productTitle}</p>
        </div>
      </div>

      <div className="flex items-center gap-3 lg:gap-6">
        <div className="flex gap-1">
          {comparePrice && (
            <p className="m-0 font-gothamBold text-xs text-grey-3 line-through lg:text-h6-m">
              {comparePrice}
            </p>
          )}
          <p className="m-0 font-gothamBold text-xs text-grey-1 lg:text-h6-m">
            {variantPrice}
          </p>
        </div>

        <button
          type="button"
          className="button button--checkout min-w-[90px] md:min-w-[160px] lg:min-w-[260px]"
          onClick={scrollTop}
          ref={buttonRef}
        >
          buy
        </button>
      </div>
    </div>
  );
}

ProductSticky.displayName = 'ProductSticky';
